import { PRICE_POLICIES_CLEAN_BONIFICATIONS } from '../constants'

export function reducer(state, action) {
  if (action.type === PRICE_POLICIES_CLEAN_BONIFICATIONS) {
    return {
      ...state,
      bonificationsPending: false,
      bonificationsError: false,
      bonificationsSuccess: false
    }
  } else {
    return state
  }
}
